module.exports = {
  // 导航栏
  navbar: {
    HOME: "首頁",
    ABOUT: "關於",
    ABOUTUS: "關於我們",
    EDITORIAL: "編輯政策",
    POLICY: "開放獲取",
    NEWS: "新聞",
    PAYMENT: "APC付款",
    JOURNALS: "期刊",
    CJOURNALS: "中文期刊",
    EJOURNALS: "英文期刊",
    SPECIALISSUES: "特殊期刊",
    SPECIALISSUESINFO: "特殊期刊詳情",
    BOOKS: "圖書/專著",
    ACABOOKS: "學術類",
    LITABOOKS: "文藝作品與教材",
    CONTACT: "聯系我們",
    CONFERENCE: "會議",
    MORE: "了解更多",
    Email: "郵箱",
    Location: "地址",
    Locationinfo: "香港尖沙咀廣東道30號新港中心一座602A室",
    Telephone: "聯系方式",
    LOGIN: "登錄",
    Search: "搜索",
    Academic: "學術著作",
    Literary: "文學藝術作品",
    Translated: "譯著",
    Name: "書名",
    Year: "出版年份",
    Prev: "上壹頁",
    Next: "下壹頁",
    visiting: "瀏覽次數",
    NoData: "暫無數據",
    BusinessScope: "業務範疇",
    Optimization: "稿件優化",
    Translat: "稿件翻譯",
    Manuscript: "稿件編排",
    Electronic: "電子書",
    GoogleRankings: "谷歌排名",
  },
  // 底部
  footer: {
    CONTACTUS: "聯系我們",
    WEBSITENAVIGATION: "網站地圖",
    ABOUTUS: ' {{ $t("navbar.ABOUTUS") }}',
    OURSERVICES: "主營業務",
    NEWS: "最新資訊",
    LIVERATE: "實時匯率",
    CUSTOMERSERVICE: "客服熱線",
    WECHAT: "微信公眾號",
  },
  // 首頁
  index: {
    SERVICES: "主營業務",
    NEWS: "最新資訊",
    GOLDMATENEWS: "公司要聞",
    MARKETINSIGHT: "匯市動態",
    KUNDAX: "坤達速匯",
    GOLDMATE: "中聯匯兌",
    GOLDMATEGROUP: "中聯集團介紹",
    KUNDAGROUP: "坤達集團介紹",
  },
};
